import { createApiStore } from "./genericStore";
import api from "../service/api";

const useRoleBase = createApiStore<any>("/role-management/roles");

export const useRoleManagementStore = () => {
  const roleBase = useRoleBase();

  return {
    ...roleBase,
    // Firmanın rollerini yetkileriyle birlikte getirir
    fetchRolesWithPermissions: async () => {
      const res = await api.get("/role-management/roles");
      return res.data;
    },
    // SaaS Modüllerini Çeker (Sadece true ve 'Module' ile bitenler)
    fetchActiveModules: async () => {
      const res = await api.get("/firm-modules/my-modules");
      return Object.keys(res.data)
        .filter(key => res.data[key] === true && key.endsWith('Module'));
    },
    // Tüm izin şemasını getirir
    fetchPermissionsSchema: async () => {
      const res = await api.get("/role/permissions-schema");
      return res.data;
    },
    // Rolün yetki matrisini günceller (Dialog ile uyumlu isim)
    updateRolePermissions: async (roleId: number, permissions: any[]) => {
      const res = await api.put(`/role-management/roles/${roleId}/permissions`, {
        permissions
      });
      return res.data;
    },
    // Kullanıcıya rol atama
    assignRoleToUser: async (userId: number, roleId: number) => {
      const res = await api.put(`/role-management/users/${userId}/assign-role`, {
        roleId
      });
      return res.data;
    }
  };
};